<template>
  <La3 :ratio="'426px 1fr'" :style="{overflowY:'hidden'}" id="NewSpGroup">
    <template slot="left">
      <div :style="{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
      }">
        <Select :defaultValue="type" @input="type=$event" :width="'170px'">
          <option :value="null">所有商品</option>
          <option v-for="t in typesp" :key="t" :value="t">{{t}}</option>
        </Select>
        <Select :defaultValue="usage" @input="usage=$event" :width="'192px'">
          <option :value="null">商品用途</option>
          <option v-for="t in usages" :key="t" :value="t">{{t}}</option>
        </Select>
      </div>
      <div :style="{width: '100%'}"><SearchInput  :defaultValue="searchText" @input="searchText=$event" :width="'100%'"/></div>
      <div :style="{width: '100%', display: 'flex', gap: '15px'}">
        <button class="pushAll" @click="items.push(...prods.map(e => { return { ...e } }))">全部加入</button>
      </div>
      <div :style="{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '10px',
        overflowY: 'auto',
        padding: '5px'

      }">
        <div draggable @dragstart="startDrag($event, prod._id)" v-for="(prod, p) in prods" :key="`prod-${p}`" class="prod">
          <div :style="{textAlign: 'start'}">{{prod.name}}</div>
          <div>${{prod.price}}</div>
        </div>
      </div>
    </template>
    <template>
    <div class="groupInfo">
      <div :style="{width: '100%'}" class="field" label="*群組名稱" ref="name"><input :style="{width:'100%'}" type="text" v-model="item.name"/></div>
      <BtnsS :style="{marginLeft: 'auto'}" @save="save" @cancel="$router.push({ name: $route.name, query: { page: '商品群組' } })"/>
    </div>
    <div class="groupInfo">
      <div class="field c" :style="{flexDirection:'row', alignItems:'center'}" label="*販售區域點" ref="area"><CheckboxVue :style="{flexDirection: 'row', flexWrap: 'wrap'}"
      :options="restaurants" :defaultValue="item.areas" @input="item.areas=$event"/></div>
    </div>
      <div class="len2">
          <div :style="{display: 'flex', alignItems:'center', justifyContent:'space-between'}">
            <div>選項</div>
            <button class="clear" @click="items=[]">清空</button>
          </div>
          <Draggable tag="div" class="items-body" v-model="items">
            <div v-for="(itmItem, j) in items" :key="`mulit-${i}-${j}`" class="mulit">
              <div :style="{display: 'flex', alignItems:'center'}">{{itmItem.name}} <div :style="{marginLeft: 'auto'}">${{itmItem.price}}</div></div>
              <DelBtn @click="items.splice(j, 1)"/>
            </div>
          </Draggable>
          <div  class="drop"
          @drop="onDrop($event, 'multi', i);changeBG(false, i+1)" :ref="`drop-${i+1}`"
          @dragenter="changeBG(true, i+1)"
          @dragleave="changeBG(false, i+1)"
          @dragover.prevent
          @dragenter.prevent></div>
        </div>
    </template>
  </La3>
</template>

<script>
import DelBtn from '../../../components/btn/del.vue'
import Draggable from 'vuedraggable'
import Select from '../../../components/select.vue'
import La3 from '../../../components/layout/La0.vue'
import SearchInput from '../../../components/input/search.vue'
import CheckboxVue from '../../../components/checkbox/checkbox.vue'
import { getapi, postapi } from '../../../store/fetch'
import { mapState } from 'vuex'
export default {
  props: ['types', 'typesp'],
  components: { La3, SearchInput, Select, Draggable, DelBtn, CheckboxVue },
  data () {
    return {
      usage: null,
      type: null,
      searchText: null,
      prods: [],
      items: [],
      item: {
        name: null,
        areas: []
      }
    }
  },
  async mounted () {
    await this.getprods()
  },
  computed: {
    id () {
      return this.$route.query.id
    },
    ...mapState({
      restaurants: 'restaurants',
      usages: 'usages'
    })
  },
  watch: {
    id: {
      async handler () {
        const { name, areas, items } = await getapi(`options/pool/edit/${this.id}`)
        this.item = { name, areas }
        this.items = items
      },
      immediate: true
    },
    searchText () { this.getprods() },
    type () { this.getprods() },
    usage () { this.getprods() }
  },
  methods: {
    async save () {
      const { name, areas } = this.item
      const items = Array.from(new Set(this.items.map(e => e._id))).map(e => this.items.find(a => a._id === e))
      const params = { name, areas, items }
      const r = await postapi(`options/pool/${this.id}`, params)
      if (r) {
        this.$router.push({ name: this.$route.name, query: { page: '特製群組' } })
      }
    },
    changeBG (bo, index) {
      const ref = this.$refs[`drop-${index}`][0] || this.$refs[`drop-${index}`]
      console.log('changeBG', bo, index, `drop-${index}`, ref)
      if (bo) {
        ref.classList.add('in')
      } else {
        ref.classList.remove('in')
      }
    },
    startDrag (event, item) {
      console.log('startDrag', item)
      event.dataTransfer.dropEffect = 'move'
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.setData('itemID', item)
    },
    onDrop (event, mode, listIndex) {
      const itemID = event.dataTransfer.getData('itemID')
      const item = this.prods.find(it => it._id === itemID)
      if (mode === 'single') {
        this.defaultItems.push(item)
      } else if (mode === 'multi') {
        this.items.push(item)
      }
    },
    async getprods () {
      const params = {}
      if (this.type) params.category = this.type
      if (this.usage) params.type = this.usage
      if (this.searchText) params.searchText = this.searchText
      this.prods = await getapi('rest_product/single?' + new URLSearchParams(params))
    }
  }

}
</script>
<style lang="scss">
#NewSpGroup {
  .La0_left {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px 20px 20px 23px;
    gap: 14px;
  }
  .La0_right {
    border-left: 1px solid #CACACA;
    display: grid;
    grid-template-rows: 40px 45px 1fr;
    align-items: center;
    padding: 14px 32px 30px 32px;
    gap: 14px;
    position: relative;
  }
}
</style>
<style lang="scss" scoped>
.groupInfo {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  align-self: flex-start;
  width: 100%;
  gap: 80px;
  input[type=text] {
    width: 100%;
    text-align: start;
    padding-inline: 1em;
  }
}
.clear {
  width: fit-content;
  padding: 5px 10px;
  letter-spacing: 2px;
  border-radius: 3px;
  background-color: #B9B9B9;
  color: #FFFFFF;
}
.pushAll {
  width: 100%;
  min-height: 40px;
  background-color: var(--color-checked);
  color: #FFFFFF;
  border-radius: 3px;
  letter-spacing: 1px;
  font-size: 18px;
}
.note {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #787878;
}
.setfields {
  overflow-y: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-right: 20px;
  height: fill;
  padding-bottom: 40px;
}
.default {
  font-weight: 400;
  font-size: 16px;
  line-height: 180%;
  color: #FFFFFF;
  width: 70px;
  height: 30px;
  background: #9DC56E;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.single, .mulit {
  display: flex;
  min-height: 40px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.1em;
  color: #787878;
  &>div:nth-child(1) {
    display: inline;
    min-width: 300px;
    width: -webkit-fill-available;
    text-align: start;
    white-space: nowrap;
  }
  .priceDiff {
    width: 200px;
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    letter-spacing: 0.05em;
    color: var(--color-pri);
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    align-items: center;
    gap: 8px;
    span {
      display: inline;
      width: 3em;
    }
    input {
      font-weight: 500;
      font-size: 18px;
      line-height: 180%;
      letter-spacing: 0.1em;
      color: #FF7373;
      text-align: center;
      width: 70px;
      height: 40px;
      border: 1px solid #C4C4C4;
      border-radius: 3px;
    }
  }
}
.items-body {
  padding-block: 14px 0;
  gap: 9px 80px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-inline: 20px;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.len2 {
  border: 2px solid var(--color-pri);
  width: 100%;
  border-radius: 10px;
  height: -webkit-fill-available;
max-height: calc(100vh - 190px);
  display: flex;
  flex-direction: column;
  &>div:nth-child(1) {
    height: 55px;
     width: 100%;
     border-bottom: 1px solid var(--color-pri);
     display: flex;
     align-items: flex-end;
     justify-content: flex-start;
     padding-block: 16px 11px;
     gap: 15px;
     &>div:nth-child(1) {
      font-weight: 500;
      font-size: 20px;
      line-height: 28px;
      letter-spacing: 0.1em;
      color: var(--color-pri);
     }
     &>div:nth-child(2) {
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      letter-spacing: 0.1em;
      color: #959595;
      vertical-align: text-bottom;
      flex: 1;
     }
  }
}
.len2>:nth-child(1) {
  padding-inline: 19px;
}

.drop {
  min-height: 60px;
  height: -webkit-fill-available;
  width: 100%;
  flex: 1;
  &.in {
    background-color: var(--color-bar);
  }
}
.prod {
  width: 100%;
  background-color: var(--color-bar);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-inline: 19px 24px;
  height: 60px;
  min-height: 60px;
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.1em;
  &>div:nth-child(2) {
    margin-left: auto;
  }
  &::after {
    content: '';
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    mask-image: url(/ham.svg);
    background-color: var(--color-pri);
    mask-repeat: no-repeat;
    mask-position: center right;
  }
}
.field {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  &.c {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    &>:nth-child(1) {
      margin-left: 14px;
    }
  }
  &::before {
    margin-right: 15px;
    white-space: nowrap;
    content: attr(label);
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 150%;
    letter-spacing: 0.1em;
    color: var(--color-pri);
  }
  &.highlight::before {
    color: red;
  }
  input[type=checkbox] {
    appearance: none;
    width: 39px;
    height: 20px;
    border-radius: 10px;
    position: relative;
      background-color: #FF8B8B;
    &:checked {
      background-color: #85CA9E;
    }
    &::before {
      content: '';
      display: inline-flex;
      width: 16px;
      height: 16px;
      position: absolute;
      left: 2px;
      right: auto;
      top: 2px;
      background-color: #FFFFFF;
      border-radius: 8px;
    }
    &:checked::before {
      right: 2px;
      left: auto;
    }
    &.invert {
      background-color: #85CA9E;
      &:checked {
        background-color: #FF8B8B;
      }
    }
  }
  textarea {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    margin-top: 14px;
    width: calc(100% - 28px);
    height: 150px;
    border: 1px solid var(--color-border);
    padding: .75em;
    border-radius: 5px;
  }
  input[type=text] {
    width: 6em;
    height: 40px;
    border: 1px solid var(--color-border);
    text-align: start;
    font-size: 20px;
    border-radius: 3px;
  }
}
</style>
